import { jsx as _jsx } from "react/jsx-runtime";
function BaseIcon() {
    return (_jsx("svg", { className: "ui-size-full", viewBox: "0 0 22 22", fill: "currentColor", children: _jsx("path", { d: "M10.8852 21.8085C16.918 21.8085 21.8085 16.9265 21.8085 10.9043C21.8085 4.882 16.918 0 10.8852 0C5.16172 0 0.466323 4.39433 0 9.98766H14.4381V11.8209H7.84171e-08C0.466323 17.4142 5.16172 21.8085 10.8852 21.8085Z" }) }));
}
export default BaseIcon;
